<template>
  <div class="coach-mark-wrapper"
       ref="coachMarkWrapper"
  >
    <div class="coach-mark">
      <div class="coach-mark-preview">
        <div class="coach-mark-preview-video-container">
          <div class="coach-mark-preview-device-status-container">
            <div class="coach-mark-preview-device-status mic"></div>
            <div class="coach-mark-preview-device-status camera"></div>
            <div class="coach-mark-guide device pc">
              <div class="coach-mark-guide-text-container">
                <p class="coach-mark-guide-title">{{ $t("deviceSetting.coachmark.deviceStatus.title") }}</p>
                <p class="coach-mark-guide-text">{{ $t("deviceSetting.coachmark.deviceStatus.text") }}</p>
              </div>
              <div class="coach-mark-guide-arrow">
                <img src="@/assets/images/coachmark/coachmark_arrow_blue_02.svg" alt="coach-mark-guide-arrow">
              </div>
            </div>
            <div class="coach-mark-guide device mobile">
              <div class="coach-mark-guide-arrow">
                <img src="@/assets/images/coachmark/coachmark_arrow_blue_05.svg" alt="coach-mark-guide-arrow">
              </div>
              <div class="coach-mark-guide-text-container">
                <p class="coach-mark-guide-text">{{ $t("deviceSetting.coachmark.deviceStatus.check") }}</p>
              </div>
            </div>
          </div>
          <div class="coach-mark-guide preview pc">
            <div class="coach-mark-guide-text-container">
              <p class="coach-mark-guide-title">{{ $t("deviceSetting.coachmark.preview.title") }}</p>
              <p class="coach-mark-guide-text">{{ $t("deviceSetting.coachmark.preview.text") }}</p>
            </div>
            <div class="coach-mark-guide-arrow">
              <img src="@/assets/images/coachmark/coachmark_arrow_blue_01.svg" alt="coach-mark-guide-arrow">
            </div>
          </div>
          <div class="coach-mark-preview-tabs-container pc">
            <div class="coach-mark-preview-tab video">{{ $t("common.video") }}</div>
            <div class="coach-mark-preview-tab audio">{{ $t("common.audio") }}</div>
            <div class="coach-mark-guide tab pc">
              <div class="coach-mark-guide-text-container">
                <p class="coach-mark-guide-title">{{ $t("deviceSetting.coachmark.tab.title") }}</p>
                <p class="coach-mark-guide-text">{{ $t("deviceSetting.coachmark.tab.text") }}</p>
              </div>
              <div class="coach-mark-guide-arrow">
                <img src="@/assets/images/coachmark/coachmark_arrow_blue_08.svg" alt="coach-mark-guide-arrow">
              </div>
            </div>
          </div>
          <div class="coach-mark-guide preview mobile">
            <div class="coach-mark-guide-arrow">
              <img src="@/assets/images/coachmark/coachmark_arrow_blue_06.svg" alt="coach-mark-guide-arrow">
            </div>
            <div class="coach-mark-guide-text-container">
              <p class="coach-mark-guide-text">{{ $t("deviceSetting.coachmark.background.check") }}</p>
            </div>
          </div>
        </div>
        <div class="coach-mark-preview-virtual-background-container">
          <div class="coach-mark-preview-virtual-background blur pc">
            <div class="coach-mark-guide blur">
              <div class="coach-mark-guide-arrow">
                <img src="@/assets/images/coachmark/coachmark_arrow_blue_04.svg" alt="coach-mark-guide-arrow">
              </div>
              <div class="coach-mark-guide-text-container">
                <p class="coach-mark-guide-title">{{ $t("deviceSetting.coachmark.background.blur.title") }}</p>
                <p class="coach-mark-guide-text">{{ $t("deviceSetting.coachmark.background.blur.text") }}</p>
              </div>
            </div>
          </div>
          <div class="coach-mark-preview-virtual-background img">
            <div class="coach-mark-guide img pc">
              <div class="coach-mark-guide-arrow">
                <img src="~@/assets/images/coachmark/coachmark_arrow_blue_03.svg" alt="coach-mark-guide-arrow">
              </div>
              <div class="coach-mark-guide-text-container">
                <p class="coach-mark-guide-title">{{ $t("deviceSetting.coachmark.background.image.title") }}</p>
                <p class="coach-mark-guide-text">{{ $t("deviceSetting.coachmark.background.image.text") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="coach-mark-footer">
        <div class="check-btn-container">
          <input type="checkbox" name="coach-mark-never-see-again" id="coach-mark-never-see-again" class="check-btn neverSeeAgain" v-model="neverSeeAgain" />
          <label for="coach-mark-never-see-again" class="check-label white">{{ $t("common.never") }}</label>
        </div>
        <button class="coach-mark-close-btn" @click="closeCoachMark">{{ $t("common.close") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {throttle} from "lodash";
import {Device} from "@/utils";

export default {
  name: 'ModalDeviceSettingCoachmark',
  props: {
    isShowCoachmark: Boolean
  },
  data() {
    return {
      guideCookieName: 'gooroomee_biz_guide__device_test',
      neverSeeAgain: false,
    }
  },
  created() {
    this.checkCookie();
  },
  mounted() {
    this.syncScroll();
  },
  methods: {
    closeCoachMark() {
      if (this.neverSeeAgain) {
        this.$setCookie(this.guideCookieName, 1, 365);
      }
      this.$emit('update:isShowCoachmark', false)
    },
    checkCookie() {
      const cookie = this.$getCookie(this.guideCookieName)
      if (cookie) {
        this.closeCoachMark()
      }
    },
    syncScroll() {
      const deviceTestElement = Device.isMobile()
        ? document.querySelector('.device-set-preview')
        : document.querySelector('.modal-device-setting-component');

      deviceTestElement.scrollTop = 0;
      this.$refs.coachMarkWrapper.addEventListener('scroll', throttle(() => {
        deviceTestElement.scrollTop = this.$refs.coachMarkWrapper.scrollTop;
      }, 1000 / 240));
    }
  }
}
</script>

<style lang="scss" scoped>
.coach-mark-wrapper {
  background-color: rgba(0, 0, 0, 0.8);
  display: grid;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  overflow-y: auto;
}
.coach-mark {
  width: 700px;
  height: 740px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.coach-mark-preview {
  width: 400px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
}
.coach-mark-preview-video-container {
  width: 312px;
  height: 175px;
  background: url('~@/assets/images/coachmark/coachmark_preview.png') no-repeat center / 100% auto;
  position: absolute;
  top: 78px;
  right: 44px;
}
.coach-mark-preview-device-status-container {
  padding-bottom: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 12px;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}
.coach-mark-preview-device-status {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &::before {
    width: 100%;
    height: 100%;
    content: '';
    position: absolute;
  }
  &.mic {
    &::before {
      background: url('~@/assets/images/mic_off_red.svg') no-repeat center / 16px auto;
    }
  }
  &.camera {
    &::before {
      background: url('~@/assets/images/cam_on_white.svg') no-repeat center / 16px auto;
    }
  }
}
.coach-mark-preview-tabs-container {
  width: 312px;
  border-radius: 30px;
  background-color: #fff;
  display: flex;
  position: absolute;
  top: calc(100% - -10px);
}
.coach-mark-preview-tab {
  flex: 1;
  font-size: 13px;
  text-align: center;
  line-height: 48px;

  &.video {
    font-weight: 700;
  }
}
.coach-mark-preview-virtual-background-container {
  width: 312px;
  height: 162px;
  display: flex;
  justify-content: center;
  position: absolute;
  right: 44px;
  bottom: 65px;
}
.coach-mark-preview-virtual-background {
  width: 100px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &.blur {
    border: 3px solid #59f;
    position: absolute;
    top: 0;

    &::before {
      content: '';
      width: 100%;
      height: 100%;
      background: url('https://biz-cdn.gooroomee.com/files/web/images/vbg/thumb_virtual_background_blur.png') no-repeat center / cover;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  &.img {
    background-color: #f1f1f1;
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0;
    bottom: 0;

    &::before {
      content: '';
      width: 12px;
      height: 12px;
      background: url('~@/assets/images/plus.svg') no-repeat center / 12px auto;
      opacity: 0.4;
      display: block;
    }
  }
}
.coach-mark-guide {
  width: max-content;
  display: flex;
  align-items: center;

  &.preview {
    text-align: right;
    position: absolute;
    right: 270px;
    bottom: 170px;
  }

  &.device {
    text-align: right;
    position: absolute;
    right: 210px;
    bottom: -16px;
  }

  &.tab {
    text-align: right;
    position: absolute;
    right: -24px;
    bottom: -60px;

    .coach-mark-guide-arrow {
      transform: translateY(-24px);
    }
  }

  &.img {
    text-align: right;
    flex-direction: column;
    align-items: flex-end;
    position: absolute;
    right: 100%;

    img {
      padding: 0 10px;
    }
  }

  &.blur {
    position: absolute;
    top: -70px;
    left: -30px;
  }
}
.coach-mark-footer {
  height: 48px;
  background: rgba(0, 0, 0, 0.3);
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
.coach-mark-guide-text-container {
  padding: 12px;
}
.coach-mark-guide-title {
  font-size: 14px;
  font-weight: 700;
  color: #54ccff;
  line-height: 19px;
}
.coach-mark-guide-text {
  margin-top: 4px;
  font-size: 13px;
  color: #fff;
  line-height: 18px;
  white-space: break-spaces;
}
.coach-mark-close-btn {
  font-size: 14px;
  color: #fff;
}
// Toggle
.check-btn-container {
  .check-btn {
    display: none;
    &:checked {
      & + .check-label {
        &::before {
          border: 1px solid #59f;
          background: #59f url('~@/assets/images/check_white.svg') no-repeat center / 6px auto;
        }
      }
    }
  }
  .check-label {
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    cursor: pointer;
    &::before {
      content: '';
      width: 15px;
      height: 15px;
      margin-right: 6px;
      border: 1px solid #fff;
      border-radius: 100%;
      background: url('~@/assets/images/check_white.svg') no-repeat center / 6px auto;
      display: block;
    }
    &.white {
      color: #fff;
    }
  }
}
.mobile {
  display: none;
}

[grm-device-mobile] {
  .coach-mark-wrapper {
    align-items: initial;
  }
  .coach-mark {
    width: 100vw;
    height: 400px;
    border-radius: 0;
  }
  .coach-mark-preview {
    width: 100%;
    display: flex;
    justify-content: center;
    top: initial;
    right: initial;
    bottom: initial;
  }
  .coach-mark-preview-video-container {
    top: 60px;
    right: initial;
  }
  .coach-mark-guide-text-container {
    padding: 4px;
  }
  .coach-mark-preview-device-status {
    border: 2px solid #54ccff;
  }
  .coach-mark-preview-virtual-background {
    &.mobile {
      &.blur {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        z-index: 2;
      }
    }
  }
  .coach-mark-guide {
    &.mobile {
      &.device {
        display: flex;
        flex-direction: column;
        right: 50px;
        bottom: -56px;
      }

      &.preview {
        display: flex;
        flex-direction: column;
        right: 170px;
        bottom: -96px;
      }

      &.blur {
        display: flex;
        top: -30px;
        right: -20px;
        z-index: 2;

        .coach-mark-guide-text {
          width: max-content;
          position: absolute;
          top: -20px;
        }
      }
    }
  }
  .coach-mark-footer {
    width: 100%;
    background-color: #444;
    display: flex;
    position: fixed;
    bottom: 0;
  }
  .coach-mark-footer-btn {
    flex: 1;
    align-items: center;
    font-size: 14px;
    color: #333;
    line-height: 52px;
    position: relative;

    &:last-of-type {
      &::before {
        content: '';
        width: 1px;
        height: 100%;
        background-color: #c9c9c9;
        position: absolute;
        left: 0;
      }
    }
  }
  .mobile {
    min-width: auto !important;
    display: block;
  }
  .pc {
    display: none;
  }
}
</style>